import React from 'react';
import { Box, Typography, CircularProgress, styled } from '@mui/material';

const TopStyledBox = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255,255,255,0.4)',
  backdropFilter: 'blur(3px)',
  zIndex: 9,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}));

const CustomizedSpinner = () => (
    <TopStyledBox>
        <CircularProgress sx={{svg: {width: '100%', height: '100%'}, height: '40px !important', width: '40px !important'}}/>
        <Typography variant="h5" mt={2} fontFamily='Inter'>
            Please wait, instance creation is in progress...
        </Typography>
    </TopStyledBox>
);

export default CustomizedSpinner;